import { render, staticRenderFns } from "./KprForm.vue?vue&type=template&id=39c20460&"
import script from "./KprForm.vue?vue&type=script&lang=js&"
export * from "./KprForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports